// Tiny hook that subscribes to the featureFlags pub-sub so any component
// reading a flag re-renders when it changes. Pair with module-level
// FEATURES[id] reads only when re-render on toggle is not required.
//
// Postgres mapping: indirect; flags ultimately come from `tenancy_features`
// (see featureFlags.js). This file is purely the React glue.
// Integration hook: replace internal pub-sub with a Redux selector
// against the tenancy slice once the tenancy API is wired.
import { useEffect, useState } from 'react';
import { FEATURES, subscribeFeatures } from './featureFlags';

// Returns the current boolean value of a tenancy feature flag and
// re-renders the calling component when the flag changes.
export default function useFeature(id) {
    const [, force] = useState(0);
    useEffect(() => subscribeFeatures(() => force((n) => n + 1)), []);
    return !!FEATURES[id];
}

// Version counter that bumps whenever any flag or per-widget entitlement
// changes. Use as a memo dependency where the value read is not a single flag
// (e.g. filtering a catalogue through isWidgetEntitled).
export function useFeaturesVersion() {
    const [tick, force] = useState(0);
    useEffect(() => subscribeFeatures(() => force((n) => n + 1)), []);
    return tick;
}
